import { Component, OnInit, Input } from '@angular/core';
import { AssigneeHelperService } from './trackeritem.browse.assignee.helper';

@Component({
  selector: 'tib-assignees-sm',
  template: require('./trackeritem.browse.assignee-sm.component.html'),
})
export class TibAssigneesSmComponent implements OnInit {
  @Input() trackerItem: any;
  @Input() maxAvatars: number;

  constructor(private assigneeHelper: AssigneeHelperService) {}

  ngOnInit() {  
    this.maxAvatars = this.maxAvatars || 1;
  }

  isAssigned(trackerItem: any): boolean {
    return this.assigneeHelper.isAssigned(trackerItem);
  }

  assigneeCount(trackerItem: any): number {
    return this.assigneeHelper.assigneeCount(trackerItem);
  }

  assigneeTitle(trackerItem: any): string {
    return this.assigneeHelper.assigneeTitle(trackerItem);
  }
}
